var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator"},[_c('div',{class:_vm.ballClass},[_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]})],2),(!_vm.withoutLine)?_c('div',{staticClass:"indicator__line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }